import React, { useState } from 'react';
import Servicesbanner from '../Servicesbanner';
import Testimonials from '../Testimonials';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify';
import { IconBrandFacebook, IconBrandInstagram, IconBrandTiktok } from '@tabler/icons-react';
import Loader from "../Loader";

const Contact = () => {
  const [loader, setLoader] = useState(false);
  const {
    control,
    formState:{errors},
    register,
    reset,
    handleSubmit
  } = useForm({ defaultValues:{
    firstName:null,
    lastName:null,
    phone:null,
    email:null,
    country:null,
    comment:null
  }});
  const handleComment = (data) => {
    setLoader(true);
    axios({
      method:"POST",
      url:`${process.env.REACT_APP_BASE_URL}/contact`,
      headers: {
        "Content-Type":"application/json"
      },
      data: JSON.stringify({
        firstName:data.firstName,
        lastName:data.lastName,
        phone:data.phone,
        email:data.email,
        country:data.country,
        comment:data.comment
      }),
    }).then(res => {
      setLoader(false);
      reset();
      toast(res.data.message, {
        type:"success",
        position:"top-right",
        theme:"light"
      });
    }).catch(err => {
      setLoader(false);
      if(err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          type:"error",
          theme:"light",
          position:"top-right"
        })
      } else {
        toast(err?.response?.data?.message || err?.message || "We're sorry! Something went wrong", {
          type:"error",
          theme:"light",
          position:"top-right"
        })
      }
    });
  }
  return (
    <>
      <Servicesbanner 
        title="Contact" 
        highlight="Us" 
      />

      <section className='contact form-section'>
        <Container>
          <Row className='justify-content-between'>
            <Col xl={4} lg={5} className='mb-lg-0 mb-5'>
              <div className="boxinfo">
                <div className="top">
                  <h2>Contact Info</h2>
                  <p>Feel free to reach out to us with your inquiries or to discuss how we can support your financial goals. We look forward to hearing from you!</p>
                  <div className="info">
                    <strong>Email : <a href="mailto:admin@myfx.ca">admin@myfx.ca</a></strong>
                    <strong>Phone : <a href="tel:14166199270">+1 (416) 619-9270</a></strong>
                    <strong>Whatsapp : <a href="https://wa.me/16476920900" target='_blank'>+1 (647) 692-0900</a></strong>
                  </div>
                </div>
                <div className="bot">
                  <h4>Stay Tuned</h4>
                  <ul className='social'>
                  <li><Link to="https://www.tiktok.com/@www_myfx.ca?_t=ZM-8spHB8yIQ0k&_r=1" target='_blank'><IconBrandTiktok size={40} stroke={1} /></Link></li>
                    <li><Link to="https://www.facebook.com/profile.php?id=100063887240664&mibextid=ZbWKwL" target='_blank'><IconBrandFacebook size={40} stroke={1} /></Link></li>
                    <li><Link to="https://www.instagram.com/myfx.ca?igsh=NWc0emxybG0ybHB1" target='_blank'><IconBrandInstagram size={40} stroke={1} /></Link></li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col xl={8} lg={7}>
              <div className="boxwrap">
                <h2 className='text-gradient' style={{lineHeight: '1'}}>Get in Touch</h2>
                <p className="mb-3">You can reach us anytime.</p>
                <Form className="row" onSubmit={handleSubmit(handleComment)}>
                  <Form.Group as={Col} md="6" className="mb-3" controlId="register-firstname">
                    <Form.Label>First name <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Enter you first name'
                      {...register("firstName", {
                        required:{ value:true, message:"First name is require" },
                        minLength:{ value:2, message:"First name is not valid" }
                      })}/>
                      { errors.firstName ? <p className='errMsg'>{errors.firstName.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="mb-3" controlId="register-firstname">
                    <Form.Label>Last name <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Enter you last name'
                      {...register("lastName", {
                        required:{value:true, message:"Last name is require"},
                        minLength:{ value:2, message:"Last name is not valid" }
                      })}/>
                      { errors.lastName ? <p className='errMsg'>{errors.lastName.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} xl="4" md="6" className="mb-3" controlId="register-phone">
                    <Form.Label>Phone <span>*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder='Enter you phone number'
                      {...register("phone", {
                        required:{value:true, message:"Phone number is require"},
                        pattern:{ value:/^(\+?\d{1,4}[\s\-]?)?(\(?\d{1,4}\)?[\s\-]?)?(\d{1,4}[\s\-]?\d{1,4}[\s\-]?\d{1,4})$/, message:"Phone number in not valid"}
                      })}/>
                      { errors.phone ? <p className='errMsg'>{errors.phone.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} xl="4" md="6" className="mb-3" controlId="register-email">
                    <Form.Label>Email address <span>*</span></Form.Label>
                    <Form.Control
                      type="email"
                      placeholder='Enter you email address'
                      {...register("email", {
                        required:{value:true, message:"Email is require"},
                        pattern: { value:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message:"Email is not valid" }
                      })}/>
                      { errors.email ? <p className='errMsg'>{errors.email.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} xl="4" lg="12" className="mb-3" controlId="register-country">
                    <Form.Label>Country <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder='Enter you country name'
                      {...register("country", {
                        required:{value:true, message:"Country name is require"}
                      })}/>
                      { errors.country ? <p className='errMsg'>{errors.country.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="register-password">
                    <Form.Label>Comments <span>*</span></Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5} placeholder='Leave a comment here'
                      {...register("comment", {
                        required:{value:true, message:"Comment is require"},
                        minLength:{value:20, message:"Comment must be at least 20 characters long"}
                      })}/>
                      {errors.comment ? <p className='errMsg'>{errors.comment.message}</p> : null}
                  </Form.Group>

                  <div className="mt-4">
                    <button type="submit" className="button blue w-100 py-3">Submit</button>
                  </div>																
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Testimonials />
      <Loader show={loader}/>
    </>
  )
}

export default Contact